const selectStyle = {
  control: (base, state) => ({
    ...base,
    borderColor: '#d9d9d9',
    boxShadow: 'none',
    ':hover ': {
      borderColor: '#d9d9d9',
      boxShadow: 'none',
    },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? '#555' : 'white',
    '&:hover': {
      backgroundColor: state.isSelected ? '#555' : '#e4e4e4',
    },
  }),
}

export default selectStyle
